export const createShortNameArr = (gameInvestments, investmentMasterData) => {
    let shortNameArr = [];
    for (let i=0; i<investmentMasterData.length; i++){
        const shortName = investmentMasterData[i].investShortName;
        shortNameArr.push(shortName);
    }
    for (let i=0; i<gameInvestments.length; i++){
        const transactionArr = gameInvestments[i].transactionArr;
        for (let j=0; j<transactionArr.length; j++){
            const shortName = transactionArr[j].investShortName;
            if (shortNameArr.includes(shortName)){
                // shortName is already in the array
            }else{
                 shortNameArr.push(shortName);
            }
        }
    }
    return shortNameArr;
}

export default createShortNameArr;